<app-view-title [showBack]="false" [showHeader]="this.userClosed" mode="split" webMode="primary"></app-view-title>

<view-content [centered]="true" [nopadding]="true">
  @if(appSettings.appType !== 'web') {
  <content-header>
    <img class="logo" src="/Styles/{{appSettings.settings.theme}}/Logo.png" />
    <br />
    <p>{{'Intellitrailer.SelectFamily.txtWelcomeMessage.' + appSettings.settings.theme | translate: 'Welcome to ' + appSettings.settings.theme + '!'}}</p>
    <h1>{{'Intellitrailer.SelectFamily.txtSelectType' | translate: 'Select trailer type'}}</h1>
  </content-header>
  }

  @if(loading) {
  <div class="spinner-container">
    <mat-spinner class="inverted-spinner" diameter="70"></mat-spinner>
    <p>{{'Interllitrailer.SelectFamily.txtLoadingMessage' | translate: 'Finding available trailers...'}}</p>
  </div>
  }
  @else 
  {
  <data-list>
    <div mobile-content class="first-visit-overlay" *ngIf="firstVisitOverlay">
      <div class="overlay-content">
          <img class="pointer" src="/assets/Images/touch-icon.png" />
        <p>{{ 'Intellitrailer.SelectFamily.firstVisit.OverlayMsg' | translate : 'Press on a model to book' }}</p>
      </div>
    </div>

    <app-card web-content *ngFor="let type of filterdCategoryList" (click)="selectType(type)">
      <img src="{{ type.ImageUri }}" />
      <h2>{{'Intellitrailer.SelectFamily.txtFamilyName_' + type.Id | translate: type.Name }}</h2>
      <small>{{'Intellitrailer.SelectFamily.txtFamilyDescription_' + type.Id | translate: type.Description}}</small>
      <div class="title-with-divider"></div>
      <button mat-raised-button>{{ 'tIntellitrailer.Booking.Components.BookingOption.Select' | translate : 'Select'}}</button>
    </app-card>

    <list-item mobile-content *ngFor="let type of filterdCategoryList" (click)="selectType(type)">
      <img src="{{ type.ImageUri }}" />
      <div>
        <h2>{{'Intellitrailer.SelectFamily.txtFamilyName_' + type.Id | translate: type.Name }}</h2>
        <small>{{'Intellitrailer.SelectFamily.txtFamilyDescription_' + type.Id | translate: type.Description}}</small>
      </div>
    </list-item>

    @if(oneWayConcept){
    <list-item mobile-content (click)="openOneWay()">
      <img src="{{ oneWayConcept.ImageUri }}" />
      <div>
        <h2>{{'Intellitrailer.SelectFamily.txtFamilyName_' + oneWayConcept.Id | translate: oneWayConcept.Name }}</h2>
        <small>{{'Intellitrailer.SelectFamily.txtFamilyDescription_' + oneWayConcept.Id | translate: oneWayConcept.Description}}</small>
      </div>
    </list-item>
    }

  </data-list>


    @if(appSettings.appType == 'web'){
    <button type="button" color="accent" mat-button (click)="skip()"> <mat-icon>map</mat-icon>{{'Intellitrailer.SelectFamily.txtAllTrailers' | translate: 'All trailers'}}</button>
    }
  }

</view-content>

@if(typeSettings.isShowMenu) {
<view-actions>
  <div (click)="toggleNewUserInfo(false)" class="link">{{'Intellitrailer_Home_Home_HowDoesItWork' | translate: 'How does it work?' }}</div>
</view-actions>
}

<app-new-user-info class="new-user-info d-flex align-items-center" *ngIf="!userClosed && typeSettings.isShowGuide" (showInfo)="toggleNewUserInfo($event)"></app-new-user-info>

